export interface ErrorResponse {
    error: any
}

export const isErrorResponse = (obj: any): obj is ErrorResponse => 'error' in obj && !!obj.error